<template>
  <SoSelect
    v-model="selectedFilters"
    :items="filterOptions"
    type="multiple"
    placeholder="Filter by type"
  />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoSelect from "@/components/formControls/SoSelect.vue"
  import { NewFeedType } from "@/types/NewFeedType"
  interface IFilterOptions {
    title: string
    value: NewFeedType
  }

  export default defineComponent({
    components: {
      SoSelect,
    },
    emits: ["update-feeds", "update-date-modelValue"],
    data() {
      return {
        selectedFilters: [] as NewFeedType[],
        filterOptions: [
          { title: "Bug", value: NewFeedType.BUG },
          { title: "Incident", value: NewFeedType.INCIDENT },
          { title: "Information", value: NewFeedType.INFO },
          { title: "Process", value: NewFeedType.PROCESS },
          { title: "Other", value: NewFeedType.OTHER },
        ] as IFilterOptions[],
      }
    },
    watch: {
      selectedFilters(newVal) {
        let filterType = ""

        if (newVal.length > 0) {
          filterType = newVal[0]
        }
        this.$emit("update-feeds", filterType)
      },
    },
  })
</script>
